import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { Selector, SelectorItems, SelectorItemsDisableReason } from '../Selector/Selector';

import * as keyset from './GroupSelector.i18n';

const i18n = i18nFactory(keyset);

export interface GroupSelectorProps {
    items?: Array<SelectorItems>;
    onInputChange: (text: string) => void;
    onItemSelect: (selectorItems: SelectorItems) => void;
    itemSelected?: SelectorItems;
    inputText?: string;
    error?: boolean;
    isActive: boolean;
    isLoading: boolean;
    itemsLimit: number;
}

export const GroupSelector = ({
    items,
    error,
    inputText,
    onInputChange,
    onItemSelect,
    isActive,
    itemSelected,
    isLoading,
    itemsLimit
}: GroupSelectorProps) => (
    <Selector
        items={items}
        cls={Bem.cls('group-selector')}
        onInputChange={onInputChange}
        onItemSelect={onItemSelect}
        placeholder={i18n('search-by-group')}
        emptyText={i18n('no-group-found')}
        awaitText={i18n('select-campaign-for-group')}
        errorText={error ? i18n('error') : ''}
        itemSelected={itemSelected}
        isLoading={isLoading}
        inputText={inputText}
        disableTooltipText={{
            // если в группе количество ообъявлений превышает лимит, то нельзя добавить ещё
            [SelectorItemsDisableReason.REACHED_COUNT_LIMIT]: i18n('banners-limit-in-group', {
                limit: itemsLimit
            }),
            // если группа архивная - нельзя добавить ещё, игнорируем количество объявлений
            [SelectorItemsDisableReason.ARCHIVED]: i18n('banners-add-archived-group')
        }}
        isActive={isActive}
    />
);
